import axios from "axios";
import React from "react";
import { alertRef } from "../../../../App";
import Dropdown from "../../../../Components/Dropdown/Dropdown";
import { Button } from "../../../../Components/StyledComponents";
import SetSMS from "../../Components/SetSMS/SetSMS";
import SetTarget from "../../Components/SetTarget/SetTarget";
import './RetentionTarget.scss';

    /* **** 
    VisitTarget 참고
    **** */
   
const RetentionTarget = () => {
    const [ days, setDays ] = React.useState(10)
    const [ title, setTitle ] = React.useState('');
    const [ text, setText ] = React.useState('');
    const [ coupon, setCoupon ] = React.useState('');
    const [ gender, setGender ] = React.useState([])
    const [ age, setAge ] = React.useState([])
    const [ targetSort, setTargetSort ] = React.useState('');
    const [ reqCount, setReqCount ] = React.useState(0);
    const [ couponInfo, setCouponInfo ] = React.useState({})

    const [ targetCount, setTargetCount ] = React.useState(0);

    const getTarget = () => {
        axios.post('/api/sms/filter',{
            Type : 'Retention',
            PointType : 'Remain',
            FilterRange : { Min : 'All', Max : 'All' },
            Day : days,
            DateRange : { Start : 'All', End : 'All'},
            Detail : {
                Age : age,
                Gender : gender,
                Limit : Number(reqCount),
                Sort : targetSort
            }
        })
        .then((data) => {
            if(data.status === 200){
                setTargetCount(data.data.TargetCount)
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })  
        })
    }

    const sendTargetSMS = () => {
        axios.put('/api/sms/filter',{
            Title : title,
            Body : text,
            Coupon : coupon,
            Type : 'Retention',
            PointType : 'Remain',
            FilterRange : { Min : 'All', Max : 'All' },
            Day : days,
            DateRange : { Start : 'All', End : 'All'},
            Detail : {
                Age : age,
                Gender : gender,
                Limit : Number(reqCount),
                Sort : targetSort
            }
        })
        .then((data) => {
            if(data.status === 204 ){
                alertRef.current.showAlert({ title : `문자 발송이 완료 되었습니다.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }else if(data.status === 200){
                alertRef.current.showAlert({ title : `보유 벨이 부족합니다.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `네트워크 상태 혹은 보유벨을 확인해주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    return (
        <div className="visit">
            <div className="box">
                <p className="title">미방문</p>

                <div className="row">
                    <Dropdown
                        width={137}
                        options={[
                            { key : '180일', value : 180},
                            { key : '60일', value : 60},
                            { key : '30일', value : 30},
                            { key : '10일', value : 10},
                        ]}
                        value={days}
                        onItemClick={(val) => setDays(val)}
                        prefix={"일"}
                    />
                    <p className="text">동안 방문하지 않은 고객</p>
                </div>
            </div>

            <SetTarget gender={gender} setGender={setGender} age={age} setAge={setAge} targetSort={targetSort} setTargetSort={setTargetSort} reqCount={reqCount} setReqCount={setReqCount} getTarget={getTarget} targetCount={targetCount}/>

            <SetSMS smsTitle={title} setSMSTitle={setTitle} smsText={text} setSMSText={setText} coupon={coupon} setCoupon={setCoupon} couponInfo={couponInfo} setCouponInfo={setCouponInfo}/>

            <Button variant='outline' disabled={ title.trim() == '' || text.trim() === '' || targetCount === 0} className="send-btn" onClick={() => alertRef.current.showAlert({ title : `타겟 문자를 발송할까요?`, isConfirm : true, confirmText : '확인', isCancel : true, cancelText : '취소', onConfirm : () => {alertRef.current.hideAlert();sendTargetSMS()} })}>
                문자 발송하기
            </Button>
        </div>
    )
}

export default RetentionTarget;